import React from 'react';
import { STATUS_META } from '../constants/referral.constants';

export default function ReferralStatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status || '—', cls: 'bg-slate-50 text-slate-700 border-slate-200' };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${meta.cls}`}>
      {meta.label}
    </span>
  );
}
